import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UsuarioDashBoardComponent } from './usuario-dashboard.component';



@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: UsuarioDashBoardComponent }    
    ])],
    exports: [RouterModule]
})
export class UsuarioDashBoardRoutingModule { }
